/** Opt-in fog diagnostics: `sessionStorage.setItem('fogDebug', '1')` or `?fogDebug=1` then reload. */

const STORAGE_KEY = 'fogDebug';

function isEnabled(): boolean {
    if (typeof window === 'undefined') return false;
    try {
        if (sessionStorage.getItem(STORAGE_KEY) === '1') return true;
        return new URLSearchParams(window.location.search).get(STORAGE_KEY) === '1';
    } catch {
        return false;
    }
}

const loggedOnce = new Set<string>();

export function fogDebugOnce(key: string, ...args: unknown[]): void {
    if (!isEnabled()) return;
    if (loggedOnce.has(key)) return;
    loggedOnce.add(key);
    console.info('[fog]', ...args);
}
